import React, { useEffect } from 'react';
import { noop } from 'lodash';
import { useABTests } from 'hooks/useABTests';
import { TranzilaGPayLastCheck } from 'config/abTests';
import { tranzilaHostedFieldsService } from 'utils/tranzilaHostedFieldsService';
import { useRoute } from 'config/routes';

const Playground: React.FC = () => {
  const { tranzilaGPayLastCheck } = useABTests();
  const { route } = useRoute();

  const isGPayLastCheck = tranzilaGPayLastCheck === TranzilaGPayLastCheck.modeB;

  const { thtk, lang, tranMode, amount, currencyCode, notifyUrl, productDescription, terminalName } = route.params as any;

  useEffect(() => {
    if (isGPayLastCheck) {
      setTimeout(() => {
        tranzilaHostedFieldsService.initGPay.call(tranzilaHostedFieldsService, thtk);
      }, 3000);
    }
  }, [ isGPayLastCheck ]);

  const handleGPay = (e: any) => {
    tranzilaHostedFieldsService.chargeGooglePayLastCheck.call(
      tranzilaHostedFieldsService,
      {
        lang,
        tranMode,
        amount: amount || undefined,
        currencyCode,
        notifyUrl,
        productDescription,
        terminalName,
        thtk,
      }
    );
  };

  const texts = [ 'Tranzila GPAY last check', 'Submit form', 'Pay with Google Pay' ];

  // TODO: remove after test
  // ?ab.tranzilaGPayLastCheck=modeB&thtk=t2db22de2f545042ba40f58fcc25344ad&lang=english&tranMode=A&amount=0.1&currencyCode=ILS&productDescription=test&terminalName=rosetaltbtok&notifyUrl=https%3A%2F%2Fwww.madlan-internal.com%2Fpaymentwebhook%2Fnotify
  return isGPayLastCheck ? (
    <div style={{ width: 280, padding: 20, margin: '40px auto', background: 'rgb(187, 187, 187)', borderRadius: 20, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div>{texts[0]}</div>
      <form onSubmit={noop}>
        <div style={{ background: '#fff', padding: 5, borderRadius: 5, height: 40, display: 'flex', alignItems: 'center' }}>
          <div id="credit_card_num" style={{ height: 30 }} />
        </div>
        <button>{texts[1]}</button>
      </form>
      <button id="payGoogle" onClick={handleGPay}>{texts[2]}</button>
    </div>
  ) : null;
};

export default Playground;
